import React, { memo } from "react";

import { TableContainer } from "../Table/index.jsx";

const HeaderFooterConfiguration = memo(({data, type, updateCell}) => {

  const RadioCell = ({value, updateCell, row: {id: index}, column: {id}}) => <div className="justify-center">
      <input 
      type='radio'
      checked={value}
      onChange={e => updateCell(type, index, id, !value)} 
    />
  </div>

  const columnDefs = React.useMemo(() =>  [
    {
      Header: I18n.t('details_max_3', {type: type}),
      accessor: 'detail',
      Cell: ({value}) => I18n.t(value),
      disableSortBy: true,
      width: 161,
      headerClasses: 'capitalize'
    },
    {
      Header: I18n.t('left'),
      accessor: 'l',
      Cell: RadioCell,
      disableSortBy: true,
      headerClasses: 'text-center',
    },
    {
      Header: I18n.t('center'),
      accessor: 'c',
      Cell: RadioCell,
      disableSortBy: true,
      headerClasses: 'text-center',
    },
    {
      Header: I18n.t('right'),
      accessor: 'r',
      Cell: RadioCell,
      disableSortBy: true,
      headerClasses: 'text-center',
    },
  ], [updateCell])
  return <TableContainer
    columns={columnDefs}
    data={Object.values(data)}
    maxHeight={false}
    isFixedSize={true}
    tableProps={{
      updateCell,
    }}
  />
})

export default HeaderFooterConfiguration;